import type { HTMLAttributes, ReactNode } from 'react';
import './selo.css';

/*
 * `info` e `rascunho` chegaram com as automações (fase 2): "Em teste" é um
 * estado que ainda não vale para todos (azul, não verde), e o rascunho é o que
 * ainda não roda (só o contorno, sem fundo).
 */
export type TomSelo = 'neutro' | 'ok' | 'atencao' | 'erro' | 'info' | 'rascunho';

export type SeloProps = {
  tom?: TomSelo;
  /**
   * O ponto que pulsa antes do texto: a coisa está rodando agora. Só para
   * estado vivo (a automação ligada); a pulsação para com movimento reduzido.
   */
  vivo?: boolean;
  children?: ReactNode;
  /*
   * O resto passa adiante: a administração anuncia o estado de um canal com
   * `role="status"`, e o selo é o elemento certo para isso — o componente não
   * pode ser o motivo de perder o anúncio.
   */
} & Omit<HTMLAttributes<HTMLSpanElement>, 'className' | 'children'>;

/**
 * Cor é o reforço, não o recado.
 *
 * O texto sempre se explica sozinho — "Funcionando", "Com falha" — porque quem
 * não distingue verde de cinza ficaria sem a resposta principal da tela.
 */
export function Selo({ tom = 'neutro', vivo = false, children, ...resto }: SeloProps) {
  return (
    <span className={tom === 'neutro' ? 'selo' : `selo selo--${tom}`} {...resto}>
      {vivo ? <span className="selo__ponto" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
